<header class="fixed-top container-fluid">

  <nav class="navbar navbar-expand-lg bg-transparent d-flex justify-content-start">
    <a class="navbar-brand" href="">
      <img src="../../../assets/images/navbar-logo.png" alt="">
    </a>
    <ul class="navbar-nav">
      <li *ngFor="let item of menuItems" class="nav-item">
        <a href="#" class="pr-2">{{item}}</a>
      </li>
    </ul>
  </nav>
</header>